"use strict";

exports.__esModule = true;
exports.enrichHierarchyWithDeviceInfo = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactSortableTree = require("react-sortable-tree");
var _Device = require("./Device");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var enrichHierarchyWithDeviceInfo = exports.enrichHierarchyWithDeviceInfo = function enrichHierarchyWithDeviceInfo(_ref) {
  var devicesMap = _ref.devicesMap,
    setTreeData = _ref.setTreeData,
    mode = _ref.mode,
    data = _ref.data,
    fontColor = _ref.fontColor,
    fontSize = _ref.fontSize,
    fontWeight = _ref.fontWeight;
  var updatedData = Object.assign({}, data, {
    devices: data.devices ? data.devices.map(function (node) {
      var name = devicesMap[node.uuid] && devicesMap[node.uuid].name ? devicesMap[node.uuid].name : node.uuid;
      var isEnabled = devicesMap[node.uuid] ? devicesMap[node.uuid].enabled : true;
      return Object.assign({}, node, {
        title: /*#__PURE__*/_react["default"].createElement(_Device.Device, {
          name: name,
          uuid: node.uuid,
          mode: mode,
          isEnabled: isEnabled,
          fontColor: fontColor,
          fontSize: fontSize,
          fontWeight: fontWeight
        }),
        type: devicesMap[node.uuid] && devicesMap[node.uuid].deviceType ? devicesMap[node.uuid].deviceType : null
      });
    }) : []
  });
  var updatedTreeData = (0, _reactSortableTree.getTreeFromFlatData)({
    flatData: updatedData.devices,
    getKey: function getKey(node) {
      return node.uuid;
    },
    getParentKey: function getParentKey(node) {
      var path = node.path.split(".");
      return path.length > 1 ? path[path.length - 2] : 0;
    },
    rootKey: 0
  });

  // expanding tree data to show expanded view initially
  var expandedTreeData = (0, _reactSortableTree.toggleExpandedForAll)({
    treeData: updatedTreeData,
    expanded: true
  });
  return setTreeData(expandedTreeData);
};